import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import CreateGift from "./pages/CreateGift";
import ViewGift from "./pages/ViewGift";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";

const darkTheme = createTheme({
  palette: {
    mode: "dark",
    primary: {
      main: "#39ff14", // Neon Green
    },
    background: {
      default: "#000000", // Black
      paper: "#121212",
    },
    text: {
      primary: "#ffffff", // White
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={darkTheme}>
      <CssBaseline />
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/create" element={<CreateGift />} />
          <Route path="/gift/:id" element={<ViewGift />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
